/* Media.co.uk trust pages: chapter nav, scroll progress, counter animation, reveal-on-scroll. */
(function () {
  'use strict';
  var root = document.querySelector('.trust-page');
  if (!root) return;

  /* ---------- Scroll progress bar ---------- */
  var bar = document.querySelector('[data-trust-progress]');
  if (bar) {
    var update = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.transform = 'scaleX(' + (pct / 100) + ')';
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------- Chapter nav: smooth scroll + active link tracking ---------- */
  var chapnav = document.querySelector('[data-trust-chapnav]');
  if (chapnav) {
    var chapLinks = chapnav.querySelectorAll('.trust-page-chap');
    var chapIds = Array.prototype.slice.call(chapLinks).map(function (l) {
      var href = l.getAttribute('href');
      return href && href.charAt(0) === '#' ? href.slice(1) : null;
    }).filter(Boolean);

    chapLinks.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var href = l.getAttribute('href');
        if (href && href.charAt(0) === '#') {
          var target = document.getElementById(href.slice(1));
          if (target) {
            e.preventDefault();
            var top = target.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
            if (history.replaceState) history.replaceState(null, '', href);
          }
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          chapLinks.forEach(function (l) { l.classList.remove('is-active'); });
          var match = chapnav.querySelector('a[href="#' + id + '"]');
          if (match) match.classList.add('is-active');
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
      chapIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) obs.observe(el);
      });
    }
  }

  /* ---------- Stat counter animation on first scroll into view ---------- */
  var counters = document.querySelectorAll('[data-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-counter'), 10);
        var pad = el.getAttribute('data-counter-pad') === '1';
        if (isNaN(target)) return;
        var start = 0;
        var dur = 1100;
        var t0 = performance.now();
        var tick = function (t) {
          var p = Math.min(1, (t - t0) / dur);
          var ease = 1 - Math.pow(1 - p, 3);
          var v = Math.round(start + (target - start) * ease);
          el.textContent = pad && v < 10 ? ('0' + v) : String(v);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        o.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.3 });
    counters.forEach(function (c) { counterObs.observe(c); });
  }

  /* ---------- Reveal-on-scroll for blocks tagged data-reveal ----------
     We mark the wrapper .is-js-ready so the opacity-0 default only kicks in
     once JS is alive. Anything already in the viewport is revealed
     immediately so the hero never sits invisible. */
  if ('IntersectionObserver' in window) {
    root.classList.add('is-js-ready');
    var revealEls = document.querySelectorAll('[data-reveal]');
    var revealNow = function (el) { el.classList.add('is-revealed'); };
    revealEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) revealNow(el);
    });
    var revealObs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealNow(entry.target);
          o.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    revealEls.forEach(function (el) {
      if (!el.classList.contains('is-revealed')) revealObs.observe(el);
    });
  }
})();
